/**
 * @description Represents the configuration settings for feature flags in both development and production environments.
 *
 * @property {boolean} dev - Indicates if the feature flag is enabled in the development environment.
 * @property {boolean} prod - Indicates if the feature flag is enabled in the production environment.
 */
const AppConfig = {
  calendly: {
    dev: false,
    prod: true,
  },

  googleTagManager: {
    dev: false,
    prod: true,
  },
  hubspot: {
    dev: false,
    prod: true,
  },
  linkedinInsights: {
    dev: false,
    prod: true,
  },
  recaptcha: {
    dev: false,
    prod: true,
  },
  segment: {
    dev: false,
    prod: true,
  },
  sentry: {
    dev: false,
    prod: true,
  },
  singpass: {
    dev: false,
    prod: true,
  },
  discordGiveaway0323: {
    dev: true,
    prod: true,
  },
  ecf: {
    dev: false,
    prod: true,
  },
  hackathon: {
    dev: true,
    prod: true,
  },
  hardcodeHamiltonHoldings: {
    dev: true,
    prod: true,
  },
  marketingOptIn: {
    dev: false,
    prod: true,
  },
  pricingGraph: {
    dev: true,
    prod: true,
  },
  paymentRef: {
    dev: true,
    prod: true,
  },
  portfolio: {
    dev: false,
    prod: true,
  },
  primaryFirmDeal: {
    dev: false,
    prod: true,
  },
  raiseCapital: {
    dev: false,
    prod: true,
  },
  topPicks: {
    dev: false,
    prod: true,
  },
  onboardingv4: {
    dev: true,
    prod: true,
  },
  mmf: {
    dev: false,
    prod: true,
  },
  singpassNoa: {
    dev: true,
    prod: true,
  },
  idenfy: {
    dev: true,
    prod: true,
  },
  partner: {
    dev: false,
    prod: true,
  },
};

export default AppConfig;
